import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import PropTypes from 'prop-types'

import Metric, { MetricContainer } from 'legacy/components/DataViz/Metrics/Metric'
import { type MetricsData } from 'legacy/components/DataViz/dataViz.types'

const MetricCollectionContainer = styled.div<{ itemsPerRow: number }>`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid ${colors.GRAY_88};
  border-left: 1px solid ${colors.GRAY_88};
  margin: -1px; // Hide superfluous border
  border-radius: 4px;
  overflow: hidden;

  ${MetricContainer} {
    flex: ${({ itemsPerRow }) => (itemsPerRow === 4 ? '1 0 25%' : '1 0 33%')};
  }
`

interface Props {
  metrics: MetricsData[]
}

export default class MetricCollection extends React.PureComponent<Props> {
  static propTypes = {
    metrics: PropTypes.arrayOf(
      PropTypes.shape({
        data: PropTypes.shape({
          title_key: PropTypes.string,
          this_period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          last_period: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          data_type: PropTypes.oneOf(['seconds', 'currency', 'number', 'percent']),
        }),
      })
    ).isRequired,
  }

  render() {
    const itemsPerRow = this.props.metrics.length <= 4 ? 4 : 3

    return (
      <MetricCollectionContainer itemsPerRow={itemsPerRow}>
        {this.props.metrics.map(({ data }) => (
          <Metric {...data} key={data.title_key} />
        ))}
      </MetricCollectionContainer>
    )
  }
}
